// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"540a7f94","224":"ebfe5f46","235":"6cbf9259","270":"45c07df2","311":"43e7cc8a","383":"640732c6","437":"eed2df15","518":"84abd384","522":"0b87177e","567":"d212654d","594":"16dcd745","638":"19cdde39","675":"d28b496c","939":"b5fad50b"}[chunkId] + ".chunk.js";
};